import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BillingCustomerService } from '../my-bill/services/billing-customer.service';

@Injectable()
export class CBUOnlyGuard {
  constructor(private customerService: BillingCustomerService) {}

  canActivate(): Observable<boolean> {
    // BUPA-7725 In the android webview there is a delay before the
    // isMyproximusMobileApp value is set
    // so we cannot use this.environmentService.isMyProximusMobileApp
    // or this.environmentService.isMillenialsMobileApp in this scenario
    // this is why here we always fetch the user data from the
    // uService cache with getCustomerAccount(false)
    return this.customerService
      .getCustomerAccount()
      .pipe(map((value) => value?.isRES() || value?.isSE()));
  }
}
